import type { TDeepthLevelStack } from '@/components/organisms/Form/Validator';
import type { TRendererSchema } from '@/components/organisms/Renderer';
import type { FunctionComponent } from 'react';

import type { GetUIElementByType } from '@ballerine/common';

import { Renderer } from '@/components/organisms/Renderer';
import { StackProvider } from '../../../FieldList/providers/StackProvider';

type IEntityFieldsProps = {
  stack: TDeepthLevelStack;
  fieldId: string;
  entityId: string;
  element: GetUIElementByType<'entityfieldgroup'>;
  elementsOverride: TRendererSchema;
  index: number;
};

export const EntityFields: FunctionComponent<IEntityFieldsProps> = ({
  stack,
  fieldId,
  entityId,
  element,
  elementsOverride,
  index,
}) => {
  return (
    <div
      key={`${fieldId}-${entityId}`}
      className="flex flex-col gap-2"
      data-testid={`${fieldId}-fieldlist-item-${entityId}`}
    >
      <StackProvider stack={[...(stack || []), index]}>
        <Renderer
          elements={element.children || []}
          schema={elementsOverride as unknown as TRendererSchema}
        />
      </StackProvider>
    </div>
  );
};
